import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as CustomActions from './custom.actions';
import { CustomEntity } from './custom.models';
import { cloneDeep } from 'lodash';
import { indexRemapping } from '../../../../../shared/src/lib/service/helper.service';
import { produce } from 'immer';
export const CUSTOM_FEATURE_KEY = 'custom';
import { messageConstant } from '../../../../../shared/src/lib/messageConstant';

export function findDuplicates(arr: any) {
  const idSet = new Set();
  for (const obj of arr) {
    const id = obj.energyId || obj.energyProcessId || obj.materialTypeId || obj.energyTypeId;
    if (idSet.has(id)) {
      return true;
    }
    idSet.add(id);
  }
}

export function validationMessage(filteredData: any, typeName: any, typeId: any) {
  const duplicateIdValues = findDuplicateIds(filteredData, typeId);
  const processRequired = filteredData.filter(
    (data: any) => data[typeName] == 'Select process' && !data[typeId]
  ).length
    ? true
    : false;
  const amountRequired = filteredData.filter((data: any) => !data?.amount).length ? true : false;
  const error =
    duplicateIdValues.length > 0
      ? 'Process already exists, select different process to procced further.'
      : processRequired
      ? 'Please fill all the mandatory information to proceed further in the process. '
      : amountRequired
      ? 'Please enter amount'
      : '';
  return error;
}

export function findDuplicateIds(data: any, typeId: any) {
  const seenIds = new Set();
  const duplicateIds: any = [];

  data.forEach((record: any) => {
    if (seenIds.has(record[typeId])) {
      duplicateIds.push(record[typeId]);
    } else {
      seenIds.add(record[typeId]);
    }
  });

  return duplicateIds;
}

export interface CustomState extends EntityState<CustomEntity> {
  selectedId?: string | number; // which Custom record has been selected
  loaded: boolean; // has the Custom list been loaded
  error?: string | null; // last known error (if any)
  deleteCustomDataMessage?: string | null; // last known error (if any)
  customMaterialList: [] | any;
  customConversionList: [] | any;
  customTruckList: [] | any;
  customReuseList: [] | any;
  customStorageList: [] | any;
  customFillingList: [] | any;
  customTransportList: [] | any;
  customWasteList: [] | any;
  materialIngredientList: [] | any;
  copiedMaterialIngredient: [] | any;
  isIngredirentEdit: boolean;
  customConversionError?: string | null;
  customConversionProcessError?: string | null;
  conversionProcessList: [] | any;
  customTruckdata: [] | any;
  customFillingdata: [] | any;
  customReuseData: [] | any;
  isIngredirentEditFilling: boolean;
  customMaterialError?: string | null;
  customMaterialProcessError?: string | null;
  customMaterialIngredirentError?: string | null;
  customFillingProcessError?: string | null;
  materialProcessList: [] | any;
  getDeleteCustomData: [] | any;
  getCopiedCustomMaterial: [] | any;
  conversionData: [] | any;
  customTruckError?: string | null;
  truckTypeList: [] | any;
  fillingIngredientList: [] | any;
  copiedFillingIngredient: [] | any;
  storageProcessList: [] | any;
  storageData: [] | any;
  copiedStorageProcess: [] | any;
  isProcessEditStorage: boolean;
  customStorageError?: string | null;
  wasteScenarioProcessList: [] | any;
  wasteScenarioData: [] | any;
  copiedWasteScenarioProcess: [] | any;
  isProcessEditWasteScenario: boolean;
  customWasteScenarioError?: string | null;
  wasteGridData: [] | any;
  reuseIngredientList: [] | any;
  reuseData: [] | any;
  customReuseError?: string | null;
  copiedReuseIngredient: [] | any;
  isIngredirentEditReuse: boolean;
  checkUpdateActionFire: boolean;
  transportScenarioList: [] | any;
  transportListRowData: [] | any;
  replicateTransportScenarioList: [] | any;
  multipleTransportScenarioList: [] | any;
  customTransportScenarioError?: string | null;
  customMultipleTransportScenarioError?: string | null;
  transportFinalGrid: [] | any;
  getDeleteCovertingProcess: [] | any;
  remainingValue: number | any;
  newCustomMaterialData: any;
  materialItems: [] | any;
  endofLifeIdentifierItems: [] | any;
  energyItems: [] | any;
  unitItems: [] | any;
  truckList: [] | any;
  refrigerationList: [] | any;
  unitofProductItems: [] | any;
  customFillingenergyItems: [] | any;
  customStorageEnergyItems: [] | any;
  customReuseEnergyItems: [] | any;
  customWestlocationItems: [] | any;
  customWestWasteMaterialItems: [] | any;
  customWestOrganizationlist: [] | any;
  wasteScenarioTempData: [] | any;
  organizationItems: [] | any;
  distanceErrorProjectCustom: '' | any;
}

export interface CustomPartialState {
  readonly [CUSTOM_FEATURE_KEY]: CustomState;
}

export const customAdapter: EntityAdapter<CustomEntity> = createEntityAdapter<CustomEntity>();

export const initialCustomState: CustomState = customAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  customMaterialList: [],
  customConversionList: [],
  customTruckList: [],
  customReuseList: [],
  customStorageList: [],
  customFillingList: [],
  customTransportList: [],
  customWasteList: [],
  deleteCustomDataMessage: '',
  materialIngredientList: [],
  copiedMaterialIngredient: null,
  isIngredirentEdit: false,
  materialProcessList: [],
  conversionProcessList: [],
  customTruckdata: [],
  customFillingdata: [],
  customReuseData: [],
  getDeleteCustomData: [],
  getCopiedCustomMaterial: [],
  conversionData: [],
  truckTypeList: [],
  fillingIngredientList: [],
  copiedFillingIngredient: null,
  isIngredirentEditFilling: false,
  storageProcessList: [],
  storageData: [],
  copiedStorageProcess: null,
  isProcessEditStorage: false,
  wasteScenarioProcessList: [],
  wasteScenarioData: [],
  copiedWasteScenarioProcess: null,
  isProcessEditWasteScenario: false,
  wasteGridData: [],
  reuseIngredientList: [],
  reuseData: [],
  copiedReuseIngredient: null,
  isIngredirentEditReuse: false,
  checkUpdateActionFire: false,
  transportScenarioList: [],
  transportListRowData: [],
  replicateTransportScenarioList: [],
  multipleTransportScenarioList: [],
  transportFinalGrid: [],
  getDeleteCovertingProcess: [],
  remainingValue: null,
  newCustomMaterialData: [],
  materialItems: [],
  endofLifeIdentifierItems: [],
  energyItems: [],
  truckList: [],
  refrigerationList: [],
  unitofProductItems: [],
  customFillingenergyItems: [],
  customStorageEnergyItems: [],
  customReuseEnergyItems: [],
  customWestOrganizationlist: [],
  customWestWasteMaterialItems: [],
  customWestlocationItems: [],
  wasteScenarioTempData: [],
  organizationItems: [],
  unitItems: [],
  distanceErrorProjectCustom: '',
});

const reducer = createReducer(
  initialCustomState,

  //reducer for CustomConversionList.
  on(CustomActions.getCustomConversionListSuccess, (state, { customConversionList }) => {
    return {
      ...state,
      customConversionList: customConversionList,
      loaded: true,
    };
  }),
  on(CustomActions.getCustomConversionListFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  //reducer for CustomTruckList.
  on(CustomActions.getCustomTruckListSuccess, (state, { customTruckList }) => {
    return { ...state, customTruckList: customTruckList, loaded: true };
  }),
  on(CustomActions.getCustomTruckListFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  //reducer for CustomReuseList.
  on(CustomActions.getCustomReuseListSuccess, (state, { customReuseList }) => {
    return { ...state, customReuseList: customReuseList, loaded: true };
  }),
  on(CustomActions.getCustomReuseListFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // reducer for CustomFIllingList
  on(CustomActions.getCustomFillingListSuccess, (state, { customFillingList }) => {
    return { ...state, customFillingList: customFillingList, loaded: true };
  }),
  on(CustomActions.getCustomReuseListFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // reducer for CustomTransportList
  on(CustomActions.getCustomTransportListSuccess, (state, { customTransportList }) => {
    return {
      ...state,
      customTransportList: customTransportList,
      loaded: true,
    };
  }),

  on(CustomActions.getCustomTransportListFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // reducer for deleteCustomData
  on(CustomActions.deleteCustomDataSuccess, (state, { deleteCustomDataMessage, id }) => {
    let filteredMaterialsData: any;
    let filteredConversionData: any;
    let filteredReuseData: any;
    let filteredStorageData: any;
    let filteredTrucksData: any;
    let filteredFillingData: any;
    let filteredWasteData: any;
    let filteredTransportData: any;
    switch (deleteCustomDataMessage.pathName) {
      case 'customMaterials':
      case 'adminCustomMaterials':
        filteredMaterialsData = state.customMaterialList.data.filter(
          (node: any) => node.customMaterialId !== id
        );
        return produce(state, draftState => {
          draftState.customMaterialList['data'] = [...filteredMaterialsData];
        });
      case 'customConversion':
      case 'adminCustomConversion':
        filteredConversionData = state.customConversionList.data.filter(
          (node: any) => node.id !== id
        );
        return produce(state, draftState => {
          draftState.customConversionList['data'] = [...filteredConversionData];
        });
      case 'customReuse':
      case 'adminCustomReuse':
        filteredReuseData = state.customReuseList.data.filter((node: any) => node.id !== id);
        return produce(state, draftState => {
          draftState.customReuseList['data'] = [...filteredReuseData];
        });
      case 'customStorage':
      case 'adminCustomStorage':
        filteredStorageData = state.customStorageList.data.filter((node: any) => node.id !== id);
        return produce(state, draftState => {
          draftState.customStorageList['data'] = [...filteredStorageData];
        });
      case 'customTrucks':
      case 'adminCustomTrucks':
        filteredTrucksData = state.customTruckList.data.filter((node: any) => node.truckId !== id);
        return produce(state, draftState => {
          draftState.customTruckList['data'] = [...filteredTrucksData];
        });
      case 'customFilling':
      case 'adminCustomFilling':
        filteredFillingData = state.customFillingList.data.filter((node: any) => node.id !== id);
        return produce(state, draftState => {
          draftState.customFillingList['data'] = [...filteredFillingData];
        });
      case 'customWaste':
      case 'adminWasteScenarios':
        filteredWasteData = state.customWasteList.data.filter(
          (node: any) => node.wasteScenarioId !== id
        );
        return produce(state, draftState => {
          draftState.customWasteList['data'] = [...filteredWasteData];
        });
      case 'customTransport':
      case 'adminCustomTransport':
        filteredTransportData = state.customTransportList.data.filter(
          (node: any) => node.id !== id
        );
        return produce(state, draftState => {
          draftState.customTransportList['data'] = [...filteredTransportData];
        });
      default:
        return { ...state };
    }
  }),

  on(CustomActions.deleteCustomDataFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  //reducer for inlineDataEdit
  on(CustomActions.inlineDataEditSuccess, (state, { customData, module, field }) => {
    switch (module.toLowerCase()) {
      case 'custommaterial':
      case 'admincustommaterial':
        return produce(state, draftState => {
          const indx = draftState.customMaterialList.data.findIndex(
            (data: any) => data.customMaterialId === customData.entityIdValue
          );
          draftState.customMaterialList['data'][indx][field] = customData.entityColumnValue;
        });
      case 'customconversion':
      case 'admincustomconversion':
        return produce(state, draftState => {
          const indx = draftState.customConversionList.data.findIndex(
            (data: any) => data.id === customData.entityIdValue
          );
          draftState.customConversionList['data'][indx][field] = customData.entityColumnValue;
        });
      case 'customreuse':
      case 'admincustomreuse':
        return produce(state, draftState => {
          const indx = draftState.customReuseList.data.findIndex(
            (data: any) => data.id === customData.entityIdValue
          );
          draftState.customReuseList['data'][indx][field] = customData.entityColumnValue;
        });
      case 'customstorage':
      case 'admincustomstorage':
        return produce(state, draftState => {
          const indx = draftState.customStorageList.data.findIndex(
            (data: any) => data.id === customData.entityIdValue
          );
          draftState.customStorageList['data'][indx][field] = customData.entityColumnValue;
        });
      case 'customtrucks':
      case 'admincustomtrucks':
        return produce(state, draftState => {
          const indx = draftState.customTruckList.data.findIndex(
            (data: any) => data.truckId === customData.entityIdValue
          );
          draftState.customTruckList['data'][indx][field] = customData.entityColumnValue;
        });
      case 'customfilling':
      case 'admincustomfilling':
        return produce(state, draftState => {
          const indx = draftState.customFillingList.data.findIndex(
            (data: any) => data.id === customData.entityIdValue
          );
          draftState.customFillingList['data'][indx][field] = customData.entityColumnValue;
        });
      case 'customwaste':
      case 'adminwastescenarios':
        return produce(state, draftState => {
          const indx = draftState.customWasteList.data.findIndex(
            (data: any) => data.wasteScenarioId === customData.entityIdValue
          );
          draftState.customWasteList['data'][indx][field] = customData.entityColumnValue;
        });
      case 'customtransport':
      case 'admincustomtransport':
        return produce(state, draftState => {
          const indx = draftState.customTransportList.data.findIndex(
            (data: any) => data.id === customData.entityIdValue
          );
          draftState.customTransportList['data'][indx][field] = customData.entityColumnValue;
        });
      default:
        return { ...state };
    }
  }),

  // reducer for getCustomStorageList
  on(CustomActions.getCustomStorageList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),

  on(CustomActions.getCustomStorageListSuccess, (state, { customStorageList }) => {
    return { ...state, customStorageList: customStorageList, loaded: true };
  }),
  on(CustomActions.getCustomStorageListFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  // reducer for CustomWasteList
  on(CustomActions.getCustomWasteList, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(CustomActions.getCustomWasteListSuccess, (state, { customWasteList }) => {
    return { ...state, customWasteList: customWasteList, loaded: true };
  }),
  on(CustomActions.getCustomWasteListFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  //reducer for custom material ingrediant
  //on(CustomActions.materialIngredient, (state) => { return ({ ...state, error: null }) }),

  on(CustomActions.addMaterialIngredient, (state, { ingredient, action, ingredientIndex }) => {
    ingredient = cloneDeep(ingredient);
    ingredient['index'] = state.materialIngredientList.length + 1;
    ingredient['enableEditing'] = true;
    return {
      ...state,
      materialIngredientList: [ingredient, ...state.materialIngredientList],
      customMaterialIngredirentError:
        'Please fill all the mandatory information to proceed further.',
    };
  }),

  on(CustomActions.deleteMaterialIngredient, (state, { ingredient, action, ingredientIndex }) => {
    const deletedIngredient = cloneDeep(ingredient);
    let maxWeight;

    let filteredData = state.materialIngredientList.filter(
      (node: any) => node.index !== deletedIngredient.index
    );
    filteredData = indexRemapping(filteredData);

    const isExist = filteredData.length > 1 ? findDuplicates(filteredData) : false;

    // To chcek maximum weight is 1000 or not
    const weight = filteredData.map((el: any) => {
      return el.weight;
    });
    if (weight.length > 0) {
      const maxWeightSum = weight.reduce((acc: any, cur: any) => acc + cur, 0);
      maxWeight = maxWeightSum <= 1000 ? false : true;
    }
    const required = filteredData.filter((data: any) => !data?.materialTypeId);

    const error = isExist
      ? 'Material already exist, select different material to procced further.'
      : maxWeight
      ? 'Total weight of materials should add up to 1000 grams (1 kg)'
      : required.length > 0
      ? 'Please fill all the mandatory information to proceed further.'
      : '';

    return {
      ...state,
      materialIngredientList: [...filteredData],
      customMaterialIngredirentError: error,
    };
  }),

  on(
    CustomActions.updateMaterialIngredient,
    (state, { ingredient, action, ingredientIndex, nodeId, colId }) => {
      const editedIngredient = cloneDeep(ingredient);
      let maxWeight;

      return produce(state, (draftState: any) => {
        const indx = draftState.materialIngredientList.findIndex(
          (data: any) => data.index === editedIngredient.index
        );
        draftState.materialIngredientList[indx][colId] = editedIngredient[colId];
        if (colId == 'materialName') {
          draftState.materialIngredientList[indx]['materialTypeId'] =
            editedIngredient['materialTypeId'];
        }
        if (colId == 'endofLifeIdentifierName') {
          draftState.materialIngredientList[indx]['endofLifeIdentifierId'] =
            editedIngredient['endofLifeIdentifierId'];
        }
        draftState.materialIngredientList[indx]['enableEditing'] =
          editedIngredient['enableEditing'];
        const isExist =
          draftState.materialIngredientList.length > 1
            ? findDuplicates(draftState.materialIngredientList)
            : false;

        // To check maximum weight is 1000 or not
        const weight = draftState.materialIngredientList.map((el: any) => {
          return el.weight;
        });
        maxWeight = weight.reduce((a: any, b: any) => a + b) > 1000 ? true : false;

        // Check for required fields
        const required = draftState.materialIngredientList.filter(
          (data: any) => !data?.materialTypeId
        );

        // Check if scrapedWeight > 0 but endofLifeIdentifierId is missing
        const scrapValidationError = draftState.materialIngredientList.some(
          (data: any) => data?.scrapedWeight > 0 && !data?.endofLifeIdentifierId
        );

        draftState.customMaterialIngredirentError = isExist
          ? 'Material already exist, select different material to proceed further.'
          : maxWeight && colId == 'weight'
          ? 'Total weight of materials should add up to 1000 grams (1 kg)'
          : scrapValidationError
          ? 'Destination of scrap is required when scraped weight is greater than zero.'
          : required.length > 0
          ? 'Please fill all the mandatory information to proceed further.'
          : '';
      });
    }
  ),

  on(CustomActions.copyMaterialIngredient, (state, { ingredient, action, ingredientIndex }) => {
    ingredient = cloneDeep(ingredient);
    ingredient['index'] = state.materialIngredientList.length + 1;
    ingredient['id'] = 1;
    const isExist = state.materialIngredientList.filter(
      (data: any) =>
        data?.materialName == ingredient.materialName &&
        data?.materialTypeId == ingredient.materialTypeId
    );
    const error =
      isExist.length > 0
        ? 'Material already exist, select different material to procced further.'
        : 'Please add atleast one material ingredient.';
    return {
      ...state,
      materialIngredientList: [ingredient, ...state.materialIngredientList],
      customMaterialIngredirentError: error,
    };
  }),

  on(CustomActions.addEditCustomMaterialSuccess, (state, { customMaterialData }) => {
    return produce(state, draftState => {
      const customMaterialDataCopy: any = {
        customMaterialId: customMaterialData.customMaterialId,
        name: customMaterialData.name,
        description: customMaterialData.description,
        packageCostSum: customMaterialData.packageCostSum,
        ownerName: customMaterialData.ownerName,
      };
      if (customMaterialData.customMaterialId) {
        const indx = draftState.customMaterialList['data'].findIndex(
          (data: any) => data.customMaterialId === customMaterialData.customMaterialId
        );
        draftState.customMaterialList['data'][indx] = customMaterialDataCopy;
      } else {
        draftState.customMaterialList['data'].push(customMaterialDataCopy);
      }
    });
  }),

  on(CustomActions.addEditCustomMaterialFailure, (state, { error }) => ({
    ...state,
    customMaterialError: error,
    customMaterialIngredirentError: error,
  })),

  on(CustomActions.openAddEditCustomMaterialModalSuccess, (state, { customMaterialdata }) => {
    return {
      ...state,
      materialIngredientList: customMaterialdata.data.materialIngrediantsItems,
      materialProcessList: customMaterialdata.data.materialProcessItems,
      newCustomMaterialData: customMaterialdata.data,
      materialItems: customMaterialdata.data.materialItems,
      endofLifeIdentifierItems: customMaterialdata.data.endofLifeIdentifierItems,
      energyItems: customMaterialdata.data.energyItems,
      organizationItems: customMaterialdata.data.organizationItems,
      unitItems: customMaterialdata.data.unitItems,
    };
  }),

  on(CustomActions.wasteScenarioProcessGrid, (state, { wasteGridData, wasteDataList }) => {
    return {
      ...state,
      wasteGridData: wasteGridData,
      wasteScenarioProcessList: wasteDataList,
    };
  }),

  on(CustomActions.clearMaterialIngredient, state => {
    return {
      ...state,
      customMaterialIngredirentError: null,
      customMaterialError: null,
    };
  }),

  on(CustomActions.clearMaterialRowData, state => {
    return {
      ...state,
      newCustomMaterialData: [],
      materialIngredientList: [],
      materialProcessList: [],
      customMaterialIngredirentError: '',
      customMaterialProcessError: '',
    };
  }),

  on(CustomActions.clearMaterialList, state => {
    return {
      ...state,
      customMaterialList: [],
    };
  }),

  on(CustomActions.clearConversionList, state => {
    return {
      ...state,
      customConversionList: [],
    };
  }),

  on(CustomActions.clearTruckList, state => {
    return {
      ...state,
      customTruckList: [],
    };
  }),

  on(CustomActions.clearReuseList, state => {
    return {
      ...state,
      customReuseList: [],
    };
  }),

  on(CustomActions.clearStorageList, state => {
    return {
      ...state,
      customStorageList: [],
    };
  }),

  on(CustomActions.clearFillingList, state => {
    return {
      ...state,
      customFillingList: [],
    };
  }),

  on(CustomActions.clearCustomWasteList, state => {
    return {
      ...state,
      // customWasteList: []
    };
  }),

  on(CustomActions.clearWasteScenarioRowDataProcess, state => {
    return {
      ...state,
      isProcessEditWasteScenario: false,
      wasteScenarioProcessList: [],
      wasteGridData: [],
      wasteScenarioData: [],
      customWestOrganizationlist: [],
      customWestWasteMaterialItems: [],
      customWestlocationItems: [],
      copiedWasteScenarioProcess: [],
    };
  }),

  //reducer for custom material process

  on(CustomActions.addMaterialProcess, (state, { process, action, processIndex }) => {
    process = cloneDeep(process);
    process['index'] = state.materialProcessList.length + 1;
    process['enableEditing'] = true;
    return {
      ...state,
      materialProcessList: [process, ...state.materialProcessList],
      customMaterialProcessError:
        'Please fill all the mandatory information to proceed further in the process.',
    };
  }),

  on(
    CustomActions.updateMaterialProcess,
    (state, { process, action, processIndex, nodeId, colId }) => {
      const editedProcess = cloneDeep(process);
      return produce(state, (draftState: any) => {
        const indx = draftState.materialProcessList.findIndex(
          (data: any) => data.index === editedProcess.index
        );
        draftState.materialProcessList[indx][colId] = editedProcess[colId];
        if (colId == 'processName') {
          draftState.materialProcessList[indx]['energyId'] = editedProcess['energyId'];
        }
        if (colId == 'unit') {
          draftState.materialProcessList[indx]['unitId'] = editedProcess['unitId'];
          draftState.materialProcessList[indx]['unitName'] = editedProcess['unitName'];
        }
        draftState.materialProcessList[indx]['enableEditing'] = editedProcess['enableEditing'];
        const isExist =
          draftState.materialProcessList.length > 1
            ? findDuplicates(draftState.materialProcessList)
            : false;

        const processRequired = draftState.materialProcessList.filter(
          (data: any) => data?.processName == 'Select material process' && !data?.energyId
        ).length
          ? true
          : false;
        const amountRequired = draftState.materialProcessList.filter((data: any) => !data?.amount)
          .length
          ? true
          : false;

        draftState.customMaterialProcessError = isExist
          ? 'Process already exists, select different process to procced further.'
          : amountRequired
          ? 'Please enter amount'
          : processRequired
          ? 'Please fill all the mandatory information to proceed further in the process.'
          : '';
      });
    }
  ),

  on(CustomActions.deleteMaterialProcess, (state, { process, action, processIndex }) => {
    const deletedProcess = cloneDeep(process);
    let filteredData = state.materialProcessList.filter(
      (node: any) => node.index !== deletedProcess.index
    );
    filteredData = indexRemapping(filteredData);
    const error = validationMessage(filteredData, 'processName', 'energyId');
    return {
      ...state,
      materialProcessList: [...filteredData],
      customMaterialProcessError: error,
    };
  }),

  on(CustomActions.clearMaterialProcess, state => {
    return {
      ...state,
      materialProcessList: [],
      customMaterialError: null,
      customMaterialProcessError: null,
    };
  }),

  on(CustomActions.clearConversionProcess, state => {
    return {
      ...state,
      conversionData: [],
      conversionProcessList: [],
      customConversionProcessError: null,
    };
  }),

  //reducer for custom material process

  on(CustomActions.addConversionProcess, (state, { process, action, processIndex }) => {
    process = cloneDeep(process);
    process['index'] = state.conversionProcessList.length + 1;
    process['enableEditing'] = true;
    return {
      ...state,
      conversionProcessList: [process, ...state.conversionProcessList],
      customConversionProcessError:
        'Please fill all the mandatory information to proceed further in the process.',
    };
  }),

  on(CustomActions.copyConversionProcess, (state, { process, action, processIndex }) => {
    process = cloneDeep(process);
    process['index'] = state.conversionProcessList.length + 1;
    process['id'] = 1;
    const isExist = state.conversionProcessList.filter(
      (data: any) => data?.energyId == process.energyId
    );
    const error =
      isExist.length > 0
        ? 'Process already exist, select different process to procced further.'
        : 'Please add atleast one process.';
    return {
      ...state,
      conversionProcessList: [process, ...state.conversionProcessList],
      customConversionProcessError: error,
    };
  }),

  on(
    CustomActions.updateConversionProcess,
    (state, { process, action, processIndex, nodeId, colId }) => {
      const editedProcess = cloneDeep(process);
      return produce(state, (draftState: any) => {
        const indx = draftState.conversionProcessList.findIndex(
          (data: any) => data.index === editedProcess.index
        );
        draftState.conversionProcessList[indx][colId] = editedProcess[colId];
        // draftState.conversionProcessList[indx]['energyId'] = editedProcess['energyId'];
        if (colId == 'processName') {
          draftState.conversionProcessList[indx]['energyId'] = editedProcess['energyId'];
        }
        draftState.conversionProcessList[indx]['enableEditing'] = editedProcess['enableEditing'];
        const isExist =
          draftState.conversionProcessList.length > 1
            ? findDuplicates(draftState.conversionProcessList)
            : false;

        const processRequired = draftState.conversionProcessList.filter(
          (data: any) => data?.processName == 'Select process' && !data?.energyId
        ).length
          ? true
          : false;
        const amountRequired = draftState.conversionProcessList.filter((data: any) => !data?.amount)
          .length
          ? true
          : false;

        draftState.customConversionProcessError = isExist
          ? 'Process already exists, select different process to procced further.'
          : amountRequired
          ? 'Please enter amount'
          : processRequired
          ? 'Please fill all the mandatory information to proceed further in the process.'
          : '';
      });
    }
  ),

  on(CustomActions.deleteConversionProcess, (state, { process, action, processIndex }) => {
    const deletedProcess = cloneDeep(process);
    let filteredData = state.conversionProcessList.filter(
      (node: any) => node.index != deletedProcess.index
    );
    filteredData = indexRemapping(filteredData);
    const error = validationMessage(filteredData, 'processName', 'energyId');
    return {
      ...state,
      conversionProcessList: [...filteredData],
      customConversionProcessError: error,
    };
  }),

  on(CustomActions.addEditCustomConversionFailure, (state, { error }) => ({
    ...state,
    customConversionProcessError: error,
  })),

  on(CustomActions.openAddEditCustomConversionModalSuccess, (state, { customConversiondata }) => {
    return {
      ...state,
      conversionProcessList: customConversiondata.data.conversionProcessDetail,
      conversionData: customConversiondata.data,
      energyItems: customConversiondata.data.energyItems,
    };
  }),

  on(CustomActions.clearCustomConversionData, state => {
    return { ...state, conversionProcessList: [], conversionData: [] };
  }),

  on(CustomActions.openAddEditCustomTruckModalSuccess, (state, { customTruckdata }) => {
    return {
      ...state,
      customTruckdata: customTruckdata.data,
      truckList: customTruckdata.data.truckList,
      refrigerationList: customTruckdata.data.refrigerationItemList,
    };
  }),

  on(CustomActions.clearCustomTrucksData, state => {
    return { ...state, customTruckdata: [] };
  }),

  on(CustomActions.openAddEditCustomFiliingModalSuccess, (state, { customFillingdata }) => {
    return {
      ...state,
      customFillingdata: customFillingdata.data,
      unitofProductItems: customFillingdata.data.unitofProductItems,
      customFillingenergyItems: customFillingdata.data.energyItems,
      organizationItems: customFillingdata.data.organizationItems,
    };
  }),

  on(CustomActions.ClearCustomFiliingData, state => {
    return { ...state, customFillingdata: [], fillingIngredientList: [] };
  }),

  on(CustomActions.addEditCustomFillingFailure, (state, { error }) => ({
    ...state,
    customFillingProcessError: error,
  })),

  on(CustomActions.openAddEditCustomFiliingModalSuccess, (state, { customFillingdata }) => {
    return {
      ...state,
      fillingIngredientList: customFillingdata.data.fillingProcessItems,
    };
  }),

  on(CustomActions.clearFillingIngredient, state => {
    return {
      ...state,
      fillingIngredientList: [],
      copiedFillingIngredient: null,
      isIngredirentEditFilling: false,
      customFillingProcessError: null,
    };
  }),
  on(CustomActions.addEditCustomStorageFailure, (state, { error }) => ({
    ...state,
    customStorageError: error,
  })),
  on(CustomActions.openAddEditCustomStorageModalSuccess, (state, { customStoragedata }) => {
    return {
      ...state,
      storageProcessList: customStoragedata.data.customStorageProcesses,
      storageData: customStoragedata.data,
      customStorageEnergyItems: customStoragedata.data.energyItems,
    };
  }),
  on(CustomActions.ClearAddEditCustomStorageModal, state => {
    return { ...state, storageProcessList: [], storageData: [] };
  }),

  on(CustomActions.storageProcessFailure, (state, { error }) => {
    return { ...state, customStorageError: error };
  }),

  on(CustomActions.addStorageProcess, (state, { process, action, processIndex }) => {
    process = cloneDeep(process);
    process['index'] = state.storageProcessList.length + 1;
    process['enableEditing'] = true;
    return {
      ...state,
      storageProcessList: [process, ...state.storageProcessList],
      customStorageError:
        'Please fill all the mandatory information to proceed further in the process.',
    };
  }),

  on(CustomActions.copyStorageProcess, (state, { process, action, processIndex }) => {
    process = cloneDeep(process);
    process['index'] = state.storageProcessList.length + 1;
    // process['id'] = 1;
    const isExist = state.storageProcessList.filter(
      (data: any) => data?.energyProcessId == process.energyProcessId
    );
    const error =
      isExist.length > 0
        ? 'Process already exist, select different process to procced further.'
        : 'Please add atleast one process.';
    return {
      ...state,
      storageProcessList: [process, ...state.storageProcessList],
      customStorageError: error,
    };
  }),

  on(
    CustomActions.updateStorageProcess,
    (state, { process, action, processIndex, nodeId, colId }) => {
      const editedProcess = cloneDeep(process);
      return produce(state, (draftState: any) => {
        const indx = draftState.storageProcessList.findIndex(
          (data: any) => data.index === editedProcess.index
        );
        draftState.storageProcessList[indx][colId] = editedProcess[colId];
        if (colId != 'amount') {
          draftState.storageProcessList[indx]['energyProcessId'] = editedProcess['energyProcessId'];
        }
        draftState.storageProcessList[indx]['enableEditing'] = editedProcess['enableEditing'];
        const isExist =
          draftState.storageProcessList.length > 1
            ? findDuplicates(draftState.storageProcessList)
            : false;
        const processRequired = draftState.storageProcessList.filter(
          (data: any) => data?.energyName == 'Select process' && !data?.energyProcessId
        ).length
          ? true
          : false;
        const amountRequired = draftState.storageProcessList.filter((data: any) => !data?.amount)
          .length
          ? true
          : false;

        draftState.customStorageError = isExist
          ? 'Process already exists, select different process to procced further.'
          : amountRequired
          ? 'Please enter amount'
          : processRequired
          ? 'Please fill all the mandatory information to proceed further in the process.'
          : '';
      });
    }
  ),

  on(CustomActions.deleteStorageProcess, (state, { process, action, processIndex }) => {
    const deletedProcess = cloneDeep(process);
    let filteredData = state.storageProcessList.filter(
      (node: any) => node.index !== deletedProcess.index
    );
    filteredData = indexRemapping(filteredData);
    const error = validationMessage(filteredData, 'energyName', 'energyProcessId');
    return {
      ...state,
      storageProcessList: [...filteredData],
      customStorageError: error,
    };
  }),

  on(CustomActions.clearStorageProcess, state => {
    return { ...state, storageProcessList: [], customStorageError: null };
  }),

  on(CustomActions.addEditCustomWasteScenarioFailure, (state, { error }) => ({
    ...state,
    customWasteScenarioError: error,
  })),
  on(
    CustomActions.openAddEditCustomWasteScenarioModalSuccess,
    (state, { customWasteScenarioData }) => {
      return {
        ...state,
        wasteScenarioProcessList: customWasteScenarioData.data.wasteMaterialList,
        wasteScenarioData: customWasteScenarioData.data,
        customWestOrganizationlist: customWasteScenarioData.data.organizationItems,
        customWestWasteMaterialItems: customWasteScenarioData.data.wasteMaterialItems,
        customWestlocationItems: customWasteScenarioData.data.locationItems,
      };
    }
  ),
  on(CustomActions.clearCustomWasteScenarioModal, state => {
    return { ...state, wasteScenarioProcessList: [], wasteScenarioData: [] };
  }),

  on(CustomActions.clearWasteScenariProcess, state => {
    return { ...state, customWasteScenarioError: '' };
  }),

  //reducer for Custom Reuse Add/edit
  on(CustomActions.addEditCustomReuseFailure, (state, { error }) => ({
    ...state,
    customReuseError: error,
  })),
  on(CustomActions.openAddEditCustomReuseModalSuccess, (state, { customReuseData }) => {
    return {
      ...state,
      reuseIngredientList: customReuseData.data.customReuseProcesses,
    };
  }),
  on(CustomActions.clearCustomReuseModal, state => {
    return { ...state, reuseIngredientList: [], reuseData: [] };
  }),

  on(CustomActions.openAddEditCustomReuseModalSuccess, (state, { customReuseData }) => {
    return {
      ...state,
      reuseData: customReuseData.data,
      customReuseEnergyItems: customReuseData.data.energyItems,
    };
  }),

  on(CustomActions.clearReuseIngredient, state => {
    return {
      ...state,
      reuseIngredientList: null,
      copiedReuseIngredient: null,
      isIngredirentEditReuse: false,
      customReuseError: null,
    };
  }),

  //reducer for Transport scenario add/edit
  on(CustomActions.addEditCustomTransportScenarioFailure, (state, { error }) => ({
    ...state,
    customTransportScenarioError: error,
  })),
  on(CustomActions.addMultipleTransportScenarioScenarioFailure, (state, { error }) => ({
    ...state,
    customMultipleTransportScenarioError: error,
  })),
  on(CustomActions.checkUpdateActionFire, (state, { check }) => ({
    ...state,
    checkUpdateActionFire: check,
  })),

  on(
    CustomActions.openAddEditCustomTransportScenarioModalSuccess,
    (state, { customTransportScenarioData, transportFinalGrid }) => {
      return {
        ...state,
        transportListRowData: customTransportScenarioData.data,
        transportScenarioList: customTransportScenarioData.data.customTransportScenarioDetails,
        replicateTransportScenarioList:
          customTransportScenarioData.data.customTransportScenarioDetails,
        multipleTransportScenarioList: transportFinalGrid,
      };
    }
  ),

  on(CustomActions.addTransportScenario, (state, { transport, action, index }) => {
    transport = cloneDeep(transport);
    transport['index'] = state.transportScenarioList.length + 1;
    transport['isOrigin'] = false;

    let error = '';
    let distanceError = '';
    if (!transport.enableMultipleSites) {
      error = state.transportScenarioList.find(
        (x: any) => x.hasOwnProperty('cityId') && x.cityId == transport.cityId
      )
        ? 'Record already exist.'
        : '';
    }
    return produce(state, (draftState: any) => {
      if (!error) {
        if (draftState.transportScenarioList.length == 0) {
          if (!transport.isCheckManualDis) {
            transport['alwaysOrigin'] = true;
          }
          draftState.transportScenarioList.push(transport);
        } else if (draftState.transportScenarioList.length > 0) {
          if (
            draftState.transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin) &&
            !transport.isCheckManualDis
          ) {
            draftState.transportScenarioList.find(
              (x: any) => !x.isOrigin && x.alwaysOrigin
            ).isOrigin = true;
          }
          draftState.transportScenarioList.push(transport);
        }
      }
      draftState.transportScenarioList.map((element: any, index: any) => {
        if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
          distanceError = messageConstant.noRecommendedConversionMessage;
        }
      });
      draftState.customTransportScenarioError = error;
      draftState.customMultipleTransportScenarioError = error;
      draftState.distanceErrorProjectCustom = distanceError;
      draftState.replicateTransportScenarioList = draftState.transportScenarioList;
    });
  }),

  on(CustomActions.updateTransportScenarioActions, (state, { transport, action, index }) => {
    return produce(state, (draftState: any) => {
      let distanceError = '';
      draftState.transportScenarioList.forEach((element: any, index: any) => {
        Object.freeze(transport);
        if ((element.distance == '0' || element.distance == '0 km') && index != 0) {
          distanceError = messageConstant.noRecommendedConversionMessage;
        }
        const objCopy = { ...transport };
        if (draftState.transportScenarioList.length == 1) {
          if (!transport.isCheckManualDis) {
            objCopy.isOrigin = false;
            objCopy.alwaysOrigin = true;
          }
          draftState.transportScenarioList[index] = objCopy;
        } else {
          if (
            draftState.transportScenarioList.find((x: any) => !x.isOrigin && x.alwaysOrigin) &&
            !transport.isCheckManualDis
          ) {
            draftState.transportScenarioList.find(
              (x: any) => !x.isOrigin && x.alwaysOrigin
            ).isOrigin = true;
          }
          const editedIngredient = objCopy;
          const updatedItem = draftState.transportScenarioList.filter(
            (data: any) => data.index == transport.index
          );
          const index = draftState.transportScenarioList.indexOf(updatedItem[0]);
          draftState.transportScenarioList[index] = editedIngredient;
          draftState.distanceErrorProjectCustom = distanceError;
        }
      });
    });
  }),

  on(CustomActions.deleteTransportScenario, (state, { transport, action, index }) => {
    transport = cloneDeep(transport);
    let filteredData = state.transportScenarioList.filter(
      (node: any) => node.cityId != transport.cityId || node.index != transport.index
    );
    filteredData = indexRemapping(filteredData);
    if (filteredData.length == 1 && !transport.isCheckManualDis) {
      filteredData.find((x: any) => x.isOrigin == true).isOrigin = false;
    }
    return {
      ...state,
      transportScenarioList: [...filteredData],
      replicateTransportScenarioList: [...filteredData],
      customTransportScenarioError: '',
      distanceErrorProjectCustom: '',
    };
  }),

  on(CustomActions.clearAddTransportScenario, state => {
    return {
      ...state,
      transportScenarioList: [],
      replicateTransportScenarioList: [],
      customTransportScenarioError: null,
      transportFinalGrid: [],
      error: null,
    };
  }),

  on(CustomActions.clearTransportScenarioRowData, state => {
    return {
      ...state,
      transportListRowData: [],
      transportScenarioList: [],
      multipleTransportScenarioList: [],
    };
  }),
  on(CustomActions.clearnDistanceError, state => {
    return {
      ...state,
      distanceErrorProjectCustom: '',
    };
  }),

  // Multiple custom transport scenario
  on(CustomActions.addMultipleTransportScenario, (state, { multiTransport, action, index }) => {
    multiTransport = cloneDeep(multiTransport);
    multiTransport['index'] = state.multipleTransportScenarioList.length + 1;
    const error = state.multipleTransportScenarioList.find(
      (x: any) => x.siteName == multiTransport.siteName
    )
      ? 'Custom site transport data already exists.'
      : '';

    return produce(state, (draftState: any) => {
      if (!error) {
        draftState.multipleTransportScenarioList.push(multiTransport);
      }
      draftState.customMultipleTransportScenarioError = error;

      const data = draftState.multipleTransportScenarioList.map((x: any) => {
        return x.productPercentage;
      });
      const total = 100;
      const sum = data.reduce((partialSum: any, a: any) => partialSum + a, 0);
      let remainingValue: any;
      if (sum <= total) {
        remainingValue = total - sum;
      } else {
        remainingValue = 'product percent exceeded';
      }

      draftState.remainingValue = remainingValue;
    });
  }),

  on(CustomActions.deleteMultipleTransportScenario, (state, { multiTransport, action, index }) => {
    multiTransport = cloneDeep(multiTransport);
    let filteredData = state.multipleTransportScenarioList.filter(
      (node: any) => node.siteId !== multiTransport.siteId || node.index !== multiTransport.index
    );
    const data = filteredData.map((x: any) => {
      return x.productPercentage;
    });
    const total = 100;
    const sum = data.reduce((partialSum: any, a: any) => partialSum + a, 0);
    let remainingValue: any;
    if (sum <= total) {
      remainingValue = total - sum;
    } else {
      remainingValue = 'product percent exceeded';
    }
    // state.remainingValue = remainingValue;
    filteredData = indexRemapping(filteredData);
    return {
      ...state,
      multipleTransportScenarioList: [...filteredData],
      customMultipleTransportScenarioError: '',
      remainingValue: remainingValue,
    };
  }),

  on(CustomActions.clearAddMultipleTransportScenario, state => {
    return {
      ...state,
      multipleTransportScenarioList: [],
      customMultipleTransportScenarioError: null,
      transportFinalGrid: null,
      transportScenarioList: [],
    };
  }),

  on(CustomActions.clearReuseIngredient, state => {
    return { ...state, reuseIngredientList: [], customReuseError: null };
  }),

  on(
    CustomActions.addWasteScenarioDataProcess,
    (state, { ingredient, action, ingredientIndex, wasteGridData }) => {
      ingredient = cloneDeep(ingredient);
      wasteGridData = cloneDeep(wasteGridData);
      ingredient['index'] = state.wasteScenarioProcessList.length + 1;
      wasteGridData['index'] = state.wasteGridData.length + 1;
      const error = '';
      return produce(state, (draftState: any) => {
        const isExist = state.wasteScenarioProcessList.filter(
          (data: any) => data?.materialId == ingredient.materialId
        );
        const error = isExist.length > 0 ? 'Material is already exist.' : '';
        if (error == '') {
          draftState.wasteScenarioProcessList.push(ingredient);
          draftState.wasteGridData.push(wasteGridData);
        }
        draftState.isProcessEditWasteScenario = false;
        draftState.copiedWasteScenarioProcess = [];
        draftState.customWasteScenarioError = error;
      });
    }
  ),

  on(
    CustomActions.updateWasteScenarioDataProcess,
    (state, { ingredient, action, ingredientIndex, wasteGridData }) => {
      ingredient = cloneDeep(ingredient);
      wasteGridData = cloneDeep(wasteGridData);
      return produce(state, (draftState: any) => {
        if (action == 'edit') {
          draftState.copiedWasteScenarioProcess = ingredient;
          draftState.isProcessEditWasteScenario = true;
        }
        if (action == 'editIngredient') {
          const isExist = state.wasteScenarioProcessList.filter(
            (data: any) =>
              data?.materialId == ingredient.materialId && data.index !== ingredientIndex
          );
          const error = isExist.length > 0 ? 'Material is already exist.' : '';
          draftState.customWasteScenarioError = error;
          if (error == '') {
            const ingredientIndx = draftState.wasteScenarioProcessList.findIndex(
              (data: any) => data.index === ingredientIndex
            );
            draftState.wasteScenarioProcessList[ingredientIndx] = ingredient;
            const wasteGridIndx = draftState.wasteGridData.findIndex(
              (data: any) => data.index === ingredientIndex
            );
            draftState.wasteGridData[wasteGridIndx] = wasteGridData;
            draftState.isProcessEditWasteScenario = false;
          }
        }
      });
    }
  ),

  on(
    CustomActions.copyWasteScenarioDataProcess,
    (state, { ingredient, action, ingredientIndex, wasteGridData }) => {
      ingredient = cloneDeep(ingredient);
      return produce(state, (draftState: any) => {
        draftState.copiedWasteScenarioProcess = ingredient;
        draftState.isProcessEditWasteScenario = false;
        draftState.customWasteScenarioError = '';
      });
    }
  ),

  on(CustomActions.addCustomWasteScenarioExistingRecord, (state, { error }) => {
    return produce(state, (draftState: any) => {
      draftState.customWasteScenarioError = error;
    });
  }),

  on(
    CustomActions.deleteWasteScenarioDataProcess,
    (state, { ingredient, action, ingredientIndex, wasteGridData }) => {
      ingredient = cloneDeep(ingredient);

      let filteredIngredientData = state.wasteScenarioProcessList.filter(
        (node: any) => node.index !== ingredient.index
      );
      filteredIngredientData = indexRemapping(filteredIngredientData);

      let filteredGridData = state.wasteGridData.filter(
        (node: any) => node.index !== ingredient.index
      );
      filteredGridData = indexRemapping(filteredGridData);

      return {
        ...state,
        wasteScenarioProcessList: [...filteredIngredientData],
        wasteGridData: [...filteredGridData],
        customWasteScenarioError: '',
      };
    }
  ),

  //#region "Custom Reuse"

  on(CustomActions.reuseIngredientFailure, (state, { error }) => {
    return { ...state, customReuseError: error };
  }),

  on(CustomActions.addReuseIngredient, (state, { ingredient, action, ingredientIndex }) => {
    ingredient = cloneDeep(ingredient);
    ingredient['index'] = state.reuseIngredientList.length + 1;
    ingredient['enableEditing'] = true;

    return {
      ...state,
      reuseIngredientList: [ingredient, ...state.reuseIngredientList],
      customReuseError:
        'Please fill all the mandatory information to proceed further in the process.',
    };
  }),

  on(CustomActions.copyReuseIngredient, (state, { ingredient, action, ingredientIndex }) => {
    ingredient = cloneDeep(ingredient);
    ingredient['index'] = state.reuseIngredientList.length + 1;
    // ingredient['id'] = 1;
    const isExist = state.reuseIngredientList.filter(
      (data: any) => data?.energyProcessId == ingredient.energyProcessId
    );
    const error =
      isExist.length > 0
        ? 'Process already exist, select different process to procced further.'
        : 'Please add atleast one process.';
    return {
      ...state,
      reuseIngredientList: [ingredient, ...state.reuseIngredientList],
      customReuseError: error,
    };
  }),

  on(
    CustomActions.updateReuseIngredient,
    (state, { ingredient, action, ingredientIndex, nodeId, colId }) => {
      const editedIngredient = cloneDeep(ingredient);
      return produce(state, (draftState: any) => {
        const indx = draftState.reuseIngredientList.findIndex(
          (data: any) => data.index === editedIngredient.index
        );
        draftState.reuseIngredientList[indx][colId] = editedIngredient[colId];
        if (colId == 'energyProcessName') {
          draftState.reuseIngredientList[indx]['energyProcessId'] =
            editedIngredient['energyProcessId'];
        }
        draftState.reuseIngredientList[indx]['enableEditing'] = editedIngredient['enableEditing'];
        const isExist =
          draftState.reuseIngredientList.length > 1
            ? findDuplicates(draftState.reuseIngredientList)
            : false;

        const processRequired = draftState.reuseIngredientList.filter(
          (data: any) => data?.energyProcessName == 'Select process' && !data?.energyProcessId
        ).length
          ? true
          : false;
        const amountRequired = draftState.reuseIngredientList.filter((data: any) => !data?.amount)
          .length
          ? true
          : false;

        draftState.customReuseError = isExist
          ? 'Process already exists, select different process to procced further.'
          : amountRequired
          ? 'Please enter amount'
          : processRequired
          ? 'Please fill all the mandatory information to proceed further in the process.'
          : '';
      });
    }
  ),

  on(CustomActions.deleteReuseIngredient, (state, { ingredient, action, ingredientIndex }) => {
    const deletedIngredient = cloneDeep(ingredient);
    let filteredData = state.reuseIngredientList.filter(
      (node: any) => node.index !== deletedIngredient.index
    );
    filteredData = indexRemapping(filteredData);
    const error = validationMessage(filteredData, 'energyProcessName', 'energyProcessId');
    return {
      ...state,
      reuseIngredientList: [...filteredData],
      customReuseError: error,
    };
  }),

  on(CustomActions.clearStorageProcess, state => {
    return { ...state, reuseIngredientList: [], customReuseError: null };
  }),

  //#endregion "My Region"

  //#region "Custom Filling"

  on(CustomActions.fillingFail, (state, { error }) => {
    return { ...state, customFillingProcessError: error };
  }),

  on(CustomActions.addfillingIngredient, (state, { ingredient, action, ingredientIndex }) => {
    ingredient = cloneDeep(ingredient);
    ingredient['index'] = state.fillingIngredientList.length + 1;
    ingredient['enableEditing'] = true;
    return {
      ...state,
      fillingIngredientList: [ingredient, ...state.fillingIngredientList],
      customFillingProcessError:
        'Please fill all the mandatory information to proceed further in the process.',
    };
  }),

  on(CustomActions.copyfillingIngredient, (state, { ingredient, action, ingredientIndex }) => {
    ingredient = cloneDeep(ingredient);
    ingredient['index'] = state.fillingIngredientList.length + 1;
    ingredient['id'] = 1;
    const isExist = state.fillingIngredientList.filter(
      (data: any) => data?.energyTypeId == ingredient.energyTypeId
    );
    const error =
      isExist.length > 0
        ? 'Process already exist, select different process to procced further.'
        : 'Please add atleast one process.';
    return {
      ...state,
      fillingIngredientList: [ingredient, ...state.fillingIngredientList],
      customFillingProcessError: error,
    };
  }),

  on(
    CustomActions.updatefillingIngredient,
    (state, { ingredient, action, ingredientIndex, nodeId, colId }) => {
      const editedIngredient = cloneDeep(ingredient);
      return produce(state, (draftState: any) => {
        const indx = draftState.fillingIngredientList.findIndex(
          (data: any) => data.index === editedIngredient.index
        );
        draftState.fillingIngredientList[indx][colId] = editedIngredient[colId];
        if (colId == 'energyName') {
          draftState.fillingIngredientList[indx]['energyTypeId'] = editedIngredient['energyTypeId'];
        }
        draftState.fillingIngredientList[indx]['enableEditing'] = editedIngredient['enableEditing'];
        const isExist =
          draftState.fillingIngredientList.length > 1
            ? findDuplicates(draftState.fillingIngredientList)
            : false;

        const processRequired = draftState.fillingIngredientList.filter(
          (data: any) => data?.processName == 'Select process' && !data?.energyTypeId
        ).length
          ? true
          : false;
        const amountRequired = draftState.fillingIngredientList.filter((data: any) => !data?.amount)
          .length
          ? true
          : false;

        draftState.customFillingProcessError = isExist
          ? 'Process already exists, select different process to procced further.'
          : amountRequired
          ? 'Please enter amount'
          : processRequired
          ? 'Please fill all the mandatory information to proceed further in the process.'
          : '';
      });
    }
  ),

  on(CustomActions.deletefillingIngredient, (state, { ingredient, action, ingredientIndex }) => {
    const deletedIngredient = cloneDeep(ingredient);
    let filteredData = state.fillingIngredientList.filter(
      (node: any) => node.index !== deletedIngredient.index
    );
    filteredData = indexRemapping(filteredData);
    const error = validationMessage(filteredData, 'processName', 'energyTypeId');
    return {
      ...state,
      fillingIngredientList: [...filteredData],
      customFillingProcessError: error,
    };
  }),

  on(CustomActions.clearfillingIngredient, state => {
    return { ...state, reuseIngredientList: [], customFillingProcessError: null };
  })

  //#endregion "My Region"
);

export function customReducer(state: CustomState | undefined, action: Action) {
  return reducer(state, action);
}
